import React, { useEffect, useState } from 'react';
import { ReactComponent as PropacityLogo } from '../../assets/propacityplush.svg';
import MobileInput from '../../components/InputGroup/MobileInput';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import InputText from '../../components/InputGroup/InputText';
import InputSelect from '../../components/InputGroup/InputSelect';
import { ReactComponent as WhiteRightNavIcon } from '../../assets/icons/whiteRightNav.svg';
import AsyncSelect from 'react-select/async';
import { getCities } from '../../services/private/csv.service';
import { toast } from 'react-toastify';
import { brokerSignup, requestCompanySignup } from '../../services/public/public.service';
import { fetchToken } from '../../firebase';
import { Oval } from 'react-loader-spinner';
import { getCompanyName } from '../../services/private/plus.leads.service';
import { ReactComponent as UserNotifyIcon } from '../../assets/plus_icon/user_notify.svg'

import { getBrokerCompanies } from '../../services/private/site-visit.service';
import RequestSentModal from './Modal/RequestSentModal';

const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const customStyles = {
    option: (styles, state) => ({
        ...styles,
        zIndex: 99,
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
    menu: (base, state) => ({
        ...base,
        zIndex: 99,
        // You can also use state.isFocused to conditionally style based on the focus state
    }),
};

const OwnerNotify = ({ setComponentName, userMobile, isOwner, name, empMobile, empEmail, setOwnerNameForInfo }) => {
    const [ownerName, setOwnerName] = useState('');
    const [mobile, setMobile] = useState(userMobile);
    const [companyName, setCompanyName] = useState('');
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showRequestSentModal, setShowRequestSentModal] = useState(true);

    const handleSubmit = async () => {

        if (!ownerName || !mobile || !companyName) {
            setError(true);
            return;
        } else {
            setError(false);
        }

        setLoading(true);
        const payload = {
            name: ownerName,
            mobile: mobile,
            name: name,
            email: empEmail,
            mobile: empMobile,
            company_name: companyName || '',
            owner_name: ownerName,
            owner_mobile: mobile,
        }
        try {
            const res = await requestCompanySignup(payload);
            if (res.data.status === 200) {
                toast.success(res.data.message)
                // setLoading(false);
                // window.location.reload();
                setComponentName('requestSent')
            }
        } catch (err) {
            setLoading(false);
            toast.error(err?.response?.data?.message)
        }
    }


    return (
        <div className='bg-white rounded-xl md:max-w-[560px] md:basis-[560px] pt-[72px] pb-[72px] px-6 grow-0 shrink-0 w-11/12 md:!mt-0 !mt-10 md:!mb-0 !mb-10 shadow-shadowcard '>
            <div className='w-[300px] !table mx-auto'>
                <div className='!table !mb-6'><UserNotifyIcon /></div>
                <div className='text-textblack font-semibold text-xl leading-8'>Notify Company Owner</div>
                <p className='text-black700 text-base leading-8 mb-0'>Send your company owner a notification to add you to the team!</p>
                <div className='!space-y-5 [&>*]:!m-0 !mt-6'>

                    <InputText
                        label='Company Owner Name'
                        placeholder='Enter Company Owner Name'
                        value={ownerName}
                        onChange={(e) => {
                            setOwnerName(e.target.value)
                            setOwnerNameForInfo(e.target.value)
                        }}
                        required={true}
                        error={(error && !ownerName) ? 'Please owner name' : ''}
                    />
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={(error && !mobile) ? 'Please enter mobile' : ''}
                        disable={userMobile ? true : false}
                        inputclass='!h-10'
                    />

                    <InputText
                        label='Company Name'
                        placeholder='Enter Company Name'
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                    />

                    <div className='!mt-6'>
                        {!loading && <button
                            type='button'
                            onClick={handleSubmit}
                            disabled={loading}
                            className='w-100 shadow-inset-blue gradient-blue text-white text-base font-medium !rounded-lg !py-2 !mt-1 inline-flex items-center gap-x-2.5 justify-center'
                        >
                            Send Message <WhiteRightNavIcon />

                        </button>}
                        {
                            loading && <button
                                disabled={true}
                                className='w-100 shadow-inset-blue bg-blue-900 text-white text-base font-medium !rounded-lg !py-2 !mt-1 inline-flex items-center gap-x-2.5 justify-center'
                            >
                                <Oval
                                    height={30}
                                    width={30}
                                    color="#FFFFFF"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                    ariaLabel='oval-loading'
                                    secondaryColor="#FFFFFF"
                                    strokeWidth={4}
                                    strokeWidthSecondary={4}
                                />
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OwnerNotify
